import { PerformanceData } from '../../types';

export const mockPerformanceData: PerformanceData = {
  summary: {
    totalClients: 247,
    activeCoaches: 6,
    completedSessions: 1843,
    avgSatisfactionScore: 4.3,
  },
  trends: {
    clientGrowth: [
      { period: '2023-07', value: 189, change: 8.2, trend: 'up' },
      { period: '2023-08', value: 198, change: 4.8, trend: 'up' },
      { period: '2023-09', value: 201, change: 1.5, trend: 'stable' },
      { period: '2023-10', value: 210, change: 4.5, trend: 'up' },
      { period: '2023-11', value: 219, change: 4.3, trend: 'up' },
      { period: '2023-12', value: 225, change: 2.7, trend: 'up' },
      { period: '2024-01', value: 232, change: 3.1, trend: 'up' },
      { period: '2024-02', value: 238, change: 2.6, trend: 'up' },
      { period: '2024-03', value: 241, change: 1.3, trend: 'stable' },
      { period: '2024-04', value: 245, change: 1.7, trend: 'stable' },
      { period: '2024-05', value: 246, change: 0.4, trend: 'stable' },
      { period: '2024-06', value: 247, change: 0.4, trend: 'stable' },
    ],
    revenueGrowth: [
      { period: '2023-07', value: 68200, change: 8.5, trend: 'up' },
      { period: '2023-08', value: 71500, change: 4.8, trend: 'up' },
      { period: '2023-09', value: 69800, change: -2.4, trend: 'down' },
      { period: '2023-10', value: 75300, change: 7.9, trend: 'up' },
      { period: '2023-11', value: 78900, change: 4.8, trend: 'up' },
      { period: '2023-12', value: 82400, change: 4.4, trend: 'up' },
      { period: '2024-01', value: 84600, change: 2.7, trend: 'up' },
      { period: '2024-02', value: 87200, change: 3.1, trend: 'up' },
      { period: '2024-03', value: 89100, change: 2.2, trend: 'up' },
      { period: '2024-04', value: 91800, change: 3.0, trend: 'up' },
      { period: '2024-05', value: 88700, change: -3.4, trend: 'down' },
      { period: '2024-06', value: 89200, change: 0.6, trend: 'stable' },
    ],
    coachPerformance: [
      { period: '2023-07', value: 4.1, change: 2.5, trend: 'up' },
      { period: '2023-08', value: 4.2, change: 2.4, trend: 'up' },
      { period: '2023-09', value: 4.1, change: -2.4, trend: 'down' },
      { period: '2023-10', value: 4.3, change: 4.9, trend: 'up' },
      { period: '2023-11', value: 4.2, change: -2.3, trend: 'down' },
      { period: '2023-12', value: 4.4, change: 4.8, trend: 'up' },
      { period: '2024-01', value: 4.3, change: -2.3, trend: 'down' },
      { period: '2024-02', value: 4.4, change: 2.3, trend: 'up' },
      { period: '2024-03', value: 4.3, change: -2.3, trend: 'down' },
      { period: '2024-04', value: 4.5, change: 4.7, trend: 'up' },
      { period: '2024-05', value: 4.3, change: -4.4, trend: 'down' },
      { period: '2024-06', value: 4.3, change: 0.0, trend: 'stable' },
    ],
    sessionMetrics: [
      { period: '2023-07', value: 142, change: 6.8, trend: 'up' },
      { period: '2023-08', value: 156, change: 9.9, trend: 'up' },
      { period: '2023-09', value: 149, change: -4.5, trend: 'down' },
      { period: '2023-10', value: 167, change: 12.1, trend: 'up' },
      { period: '2023-11', value: 172, change: 3.0, trend: 'up' },
      { period: '2023-12', value: 178, change: 3.5, trend: 'up' },
      { period: '2024-01', value: 184, change: 3.4, trend: 'up' },
      { period: '2024-02', value: 191, change: 3.8, trend: 'up' },
      { period: '2024-03', value: 187, change: -2.1, trend: 'down' },
      { period: '2024-04', value: 195, change: 4.3, trend: 'up' },
      { period: '2024-05', value: 189, change: -3.1, trend: 'down' },
      { period: '2024-06', value: 193, change: 2.1, trend: 'up' },
    ],
  },
  comparisons: {
    monthOverMonth: {
      current: 89200,
      previous: 88700,
      change: 500,
      percentage: 0.6,
    },
    yearOverYear: {
      current: 89200,
      previous: 69800,
      change: 19400,
      percentage: 27.8,
    },
    quarterOverQuarter: {
      current: 269100, // Q2 2024
      previous: 265500, // Q1 2024
      change: 3600,
      percentage: 1.4,
    },
  },
  goals: {
    revenueTarget: 100000,
    clientTarget: 275,
    retentionTarget: 92.0,
    satisfactionTarget: 4.5,
  },
};

export const mockExecutiveSummary = {
  keyMetrics: [
    { metric: 'Total Revenue (YTD)', current: 487000, target: 520000, performance: 93.7 },
    { metric: 'Active Clients', current: 247, target: 275, performance: 89.8 },
    { metric: 'Client Retention Rate', current: 87.3, target: 92.0, performance: 94.9 },
    { metric: 'Avg Satisfaction Score', current: 4.3, target: 4.5, performance: 95.6 },
    { metric: 'Monthly Revenue', current: 89200, target: 100000, performance: 89.2 },
    { metric: 'Coach Utilization', current: 78.4, target: 85.0, performance: 92.2 },
  ],
  achievements: [
    'Exceeded Q2 revenue target by 8.3%',
    'Achieved 94.2% client satisfaction rate',
    'Reduced client churn by 18% compared to last year',
    'Expanded to 3 new geographic markets',
    'Launched premium tier with 36% adoption rate',
  ],
  challenges: [
    'Client acquisition cost increased by 12%',
    'Coach capacity constraints in peak hours',
    'Payment processing delays affecting cash flow',
    'Seasonal client activity dip in summer months',
  ],
  priorities: [
    'Optimize client acquisition channels',
    'Implement automated scheduling system',
    'Enhance payment processing infrastructure',
    'Develop summer engagement programs',
  ],
};

export const mockOperationalMetrics = [
  { metric: 'Coach Utilization Rate', value: 78.4, target: 85.0, trend: 'up', change: 3.2 },
  { metric: 'Avg Response Time', value: 4.2, target: 3.0, trend: 'down', change: -0.8 },
  { metric: 'Session Completion Rate', value: 92.6, target: 95.0, trend: 'up', change: 2.1 },
  { metric: 'Goal Achievement Rate', value: 76.8, target: 80.0, trend: 'up', change: 4.3 },
  { metric: 'Client Check-in Rate', value: 85.7, target: 90.0, trend: 'stable', change: 0.5 },
  { metric: 'Program Adherence Rate', value: 81.3, target: 85.0, trend: 'up', change: 2.9 },
];

export const mockBenchmarkData = [
  { category: 'Client Retention', ourValue: 87.3, industryAvg: 82.1, percentile: 78 },
  { category: 'Client Satisfaction', ourValue: 4.3, industryAvg: 4.1, percentile: 72 },
  { category: 'Revenue Growth', ourValue: 27.8, industryAvg: 15.4, percentile: 85 },
  { category: 'Coach Utilization', ourValue: 78.4, industryAvg: 75.8, percentile: 64 },
  { category: 'Response Time', ourValue: 4.2, industryAvg: 6.1, percentile: 82 },
  { category: 'Session Completion', ourValue: 92.6, industryAvg: 88.9, percentile: 76 },
]; 